"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacySection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const mediaQueries_1 = require("../../styles/mediaQueries");
function PrivacySection({ title, options, icon, hint, hintURL, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const imgSharingLink = t(i18n_1.Strings.firstLaunchOnboarding.privacy.imageSharingURL);
    const onHintClick = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.openWebView({ url: hintURL });
    };
    const onLinkClick = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.openWebView({ url: imgSharingLink });
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'PrivacySection_Container', children: [(0, jsx_runtime_1.jsxs)(HeadingContainer, { "data-e2e": 'PrivacySection_HeadingContainer', children: [(0, jsx_runtime_1.jsx)(ImageContainer, { "data-e2e": 'PrivacySection_ImageContainer', children: (0, jsx_runtime_1.jsx)(StyledIcon, { name: icon, "data-e2e": 'PrivacySection_StyledIcon' }) }), (0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'PrivacySection_Title', children: title }), (0, jsx_runtime_1.jsx)(Hint, { onClick: onHintClick, size: ui_1.ButtonSize.Small, "data-e2e": 'PrivacySection_Hint', children: hint })] }), (0, jsx_runtime_1.jsx)(Options, { "data-e2e": 'PrivacySection_Options', children: Object.entries(options).map(([key, option]) => {
                    //imgsharing hack for interactive components
                    if (key === 'imagesSharing') {
                        return ((0, jsx_runtime_1.jsx)(Option, { "data-e2e": 'PrivacySection_Option', children: (0, jsx_runtime_1.jsxs)(i18n_1.Trans, { i18nKey: i18n_1.Strings.firstLaunchOnboarding.privacy.sections.youShouldKnow
                                    .options.imagesSharing, "data-e2e": 'PrivacySection_Trans', children: ["You can share up to 5 images and 10 seconds of video content outside of the app, with", (0, jsx_runtime_1.jsxs)(Link, { onClick: () => onLinkClick, size: ui_1.ButtonSize.Small, "data-e2e": 'PrivacySection_Link', children: [' ', "some restrictions"] })] }) }, key));
                    }
                    return (0, jsx_runtime_1.jsx)(Option, { "data-e2e": 'PrivacySection_Option', children: option }, key);
                }) })] }));
}
exports.PrivacySection = PrivacySection;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  height: 32px;
  width: 32px;
`;
const Container = styled_components_1.default.div `
  max-width: 440px;
  padding-top: 6px;
  padding-right: 30px;
  padding-left: 30px;
`;
const HeadingContainer = styled_components_1.default.div `
  display: flex;
  align-items: start;
  color: ${({ theme }) => theme.text};
`;
const ImageContainer = styled_components_1.default.div `
  width: 32px;
  height: 32px;

  margin-top: -6px;
  margin-right: 8px;
`;
const Title = styled_components_1.default.h3 `
  max-width: 37%;

  ${mediaQueries_1.device.mobileLandscape `
    max-width: 45%;
  `}
  margin: 0;

  color: ${props => props.theme.text};
  font-weight: 600;
  font-size: 16px;
`;
const Hint = (0, styled_components_1.default)(ui_1.FlatButton) `
  margin: 0 0 0 auto;
  padding: 0;

  color: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.background};
  font-family: 'Main CA Font', sans-serif;
  line-height: 1.5;
`;
const Options = styled_components_1.default.ul `
  margin: 10px 0;

  color: ${({ theme }) => theme.settings.text};
  font-size: 14px;
  line-height: 1.71;

  padding-inline-start: 30px;
`;
const Option = styled_components_1.default.li `
  padding-left: 10px;
`;
const Link = (0, styled_components_1.default)(ui_1.FlatButton) `
  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.background};
  line-height: 1.5;
`;
